module.exports = __webpack_public_path__ + "static/media/HadyLogo.c02408b6.svg";